<script setup lang="ts">
defineProps<{
	totalCount: number
}>()

const emit = defineEmits<{
	page: [value: number]
}>()
</script>

<template>
	<UPagination
		v-slot="{ page }"
		:total="totalCount"
		:sibling-count="1"
		:items-per-page="10"
		show-edges
		:default-page="1"
		@update:page="emit('page', $event)">
		<UPaginationList
			v-slot="{ items }"
			class="flex items-center gap-1">
			<UPaginationFirst />

			<UPaginationPrev />

			<template v-for="(item, index) in items">
				<BlogPaginationItem
					v-if="item.type === 'page'"
					:key="index"
					:page
					:value="item.value" />

				<UPaginationEllipsis
					v-else
					:key="item.type"
					:index="index" />
			</template>

			<UPaginationNext />

			<UPaginationLast />
		</UPaginationList>
	</UPagination>
</template>
